module.exports = __webpack_public_path__ + "media/country_flags/gb-3b4178f2.png";